import { combineReducers } from 'redux'
import FoodGroupReducer from './FoodGroupReducer'
import FoodReducer from './FoodReducer'
import CartReducer from './CartReducer'
import AppReducer from './AppReducer'
import RestaurantReducer from './RestaurantReducer'
import AccountReducer from './AccountReducer'
import OrderReducer from './OrderReducer'
import CacheReducer from './CacheReducer'
import ModalReducer from './ModalReducer'

const rootReducer = combineReducers({
    FoodGroupReducer,
    FoodReducer,
    CartReducer,
    AppReducer,
    RestaurantReducer,
    AccountReducer,
    OrderReducer,
    CacheReducer,
    ModalReducer
})

export default rootReducer
